import { render, staticRenderFns } from "./OrganPersonDescriptionInfoView.vue?vue&type=template&id=d88075cc&scoped=true"
import script from "./OrganPersonDescriptionInfoView.vue?vue&type=script&lang=js"
export * from "./OrganPersonDescriptionInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88075cc",
  null
  
)

export default component.exports